import { Nav, Collapse, Image, Row } from "react-bootstrap";
import { List } from "react-bootstrap-icons";
import NavItem from "../common/NavItem";
import React, { useContext, useEffect, useRef, useState } from "react";
import godrejLogo from "../../assets/images/godrej-logo-dark.svg";
import { userlogo } from "../../helpers/formatter";
import { useMsal } from "@azure/msal-react";
import { AuthContext } from "../../contexts/AuthContext";
import enquiryIcon from "../../assets/icons/EnquiryIcon.svg";
import adminIcon from "../../assets/icons/admin.svg";
import orderBookingIcon from "../../assets/icons/TransactionsGray.svg";
import discountIcon from "../../assets/icons/DiscountSanction.svg"
import timelineIcon from "../../assets/icons/PreOrderTimeline.svg";

export default function SideBar(props) {
  const context = useContext(AuthContext);
  const sidebarRef = useRef(null);


  let icons = { "Dashboard": enquiryIcon,"Discount Sanction":discountIcon }
  const [open, setOpen] = useState({});
  const [authorizedSessions, setAuthorizedSessions] = useState({});


  const { instance } = useMsal();

  function handleLogout(instance) {
    sessionStorage.clear()
    instance.logoutRedirect().catch((e) => {
      console.error(e);
    });
  }

  useEffect(() => {
    if (props.sidebar == "closed") {
      setOpen({})
    }
  }, [props.sidebar])



  useEffect(() => {
    function handleClickOutside(event) {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        props.setSidebar("closed");
      }
    }

    // document.addEventListener("mousedown", handleClickOutside);
    // return () => {
    //   document.removeEventListener("mousedown", handleClickOutside);
    // };
  }, []);


  const setMenu = () => {
    try {
      let authorizedSessionsTempArr = []
      let authorizedSessionsTemp = {}

      // let authorizedSessions = sessionStorage.getItem("AuthorizedSessions");
      let authorizedSessions = context.authorizedSessions;
      // console.log(" authorizedSessions ", authorizedSessions);
      // if (authorizedSessions && authorizedSessions != "") {

      //   authorizedSessions = authorizedSessions;
      // }
      for (const element of authorizedSessions) {
        authorizedSessionsTempArr.push(element)
      }
      authorizedSessionsTempArr.forEach(obj => {
        const key = Object.keys(obj)[0];
        //  const allFalse = obj[key].every(record => record.Read == false && record.Write == false);
        const allFalse = true;
        // console.log("authorizedSessionsTempArr key", key, " allFalse ", allFalse)
        // if (!allFalse ) {

        authorizedSessionsTemp[key] = obj[key]
      });
      setAuthorizedSessions(authorizedSessionsTemp);
    } catch (error) {
      console.log(error)
    }
  }
  useEffect(() => {
    setMenu();
  }, [])
  return (
    <>
      <div className="sidebar-head" ref={sidebarRef}>
        <button className="head-toggle" onClick={() => { props.setSidebar(props.sidebar === "closed" ? "open" : "closed") }}></button>
        {props.sidebar === 'open' && <Image className="head-logo me-5 my-1" src={godrejLogo} />}
      </div>

      <div className={`sidebar-body ${props.sidebar}`} ref={sidebarRef}>
        <Nav bsPrefix="nav-list" defaultActiveKey={"Dashboard"}>
          <NavItem menuType={"menu"} menu={"Enquiry"} path={"/home"} icon={enquiryIcon} setSidebar={props.setSidebar} sidebar={props.sidebar}></NavItem>
          <NavItem menuType={"menu"} menu={"Discount Sanction"} path={"/discountsanction"} icon={discountIcon} setSidebar={props.setSidebar} sidebar={props.sidebar}></NavItem>
          <NavItem menuType={"menu"} menu={"Pre-Order Timeline"} path={"/timeline"} icon={timelineIcon} setSidebar={props.setSidebar} sidebar={props.sidebar}></NavItem>
          <NavItem menuType={"menu"} menu={"Order Booking"} path={"/orderbooking"} icon={orderBookingIcon} setSidebar={props.setSidebar} sidebar={props.sidebar}></NavItem>
        </Nav>
      </div>
    </>
  );
}
